var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashewNuts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "cashew_nuts",
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noix de cajou") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noix-de-cajou",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 2,
    cx: 50,
    cy: 38,
    r: 37
  }), /*#__PURE__*/React.createElement("text", {
    id: "cajou",
    xmlSpace: "preserve",
    x: 25,
    y: 119,
    fontFamily: "OpenSansCondensed-Bold, Open Sans Condensed",
    fontSize: 20,
    fontWeight: 500,
    fill: "#000000"
  }, "cajou"), /*#__PURE__*/React.createElement("text", {
    id: "noix-de",
    xmlSpace: "preserve",
    x: 16,
    y: 97,
    fontFamily: "OpenSansCondensed-Bold, Open Sans Condensed",
    fontSize: 20,
    fill: "#000000"
  }, "noix de"), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(28.026350, 17.834000)",
    fill: "#161615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.973650, 0.166000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8628879,30.6465319 C35.4279467,34.9315532 30.5106526,37.2906383 25.0168879,37.2906383 C20.3474761,37.2906383 15.5742997,35.5580426 11.214535,32.280383 C1.37500554,24.882 -1.28993563,13.4657872 4.86182907,5.15546809 C4.88982907,5.12061702 7.67912319,1.65957447 11.5315938,1.65957447 C12.4086526,1.65957447 13.2898291,1.8396383 14.1520644,2.19395745 C19.2933585,4.30659574 20.7427702,10.3001489 19.518182,15.1278511 C18.8618291,17.7167872 19.3806526,20.4442979 20.9050055,22.4233404 C22.6862997,24.7351277 25.5390055,25.6844043 28.4839467,24.9135319 C33.6540644,23.5568298 35.8306526,23.1709787 37.9973585,24.2148511 C38.7838291,24.5948936 39.7588879,25.5732128 40.0397114,26.8245319 C40.3131232,28.0451489 39.9170055,29.3313191 38.8628879,30.6465319 Z M41.6464173,26.4585957 C41.2148879,24.5359787 39.7942997,23.2423404 38.7080644,22.7179149 C37.6514761,22.2084255 36.5710055,21.9711064 35.3044173,21.9711064 C33.5033585,21.9711064 31.3712408,22.440766 28.0688879,23.3078936 C25.7687702,23.9128085 23.5831232,23.1925532 22.206182,21.4051915 C20.9906526,19.827766 20.582182,17.6354681 21.1133585,15.5385957 C22.5150055,10.0147021 20.7880644,3.12829787 14.7746526,0.657191489 C13.7139467,0.221553191 12.6227702,0 11.5315938,0 C6.87124084,0 3.70477025,3.95476596 3.55735849,4.14229787 C-3.07205328,13.0973617 -0.203700338,25.7657234 10.2295938,33.6097021 C14.8767702,37.1039362 19.9900644,38.9502128 25.0168879,38.9502128 C31.0179467,38.9502128 36.3906526,36.3720638 40.1442997,31.6887447 C41.8712408,29.534617 41.9140644,27.6559787 41.6464173,26.4585957 L41.6464173,26.4585957 Z",
    id: "Fill-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70982907,9.49359574 C6.91982907,9.08782979 6.76335849,8.58746809 6.36147613,8.37504255 C5.95712319,8.16261702 5.45971143,8.3202766 5.24971143,8.72604255 C5.20524084,8.81234043 0.875946721,17.4014681 7.77053496,25.5690638 C7.93359378,25.7615745 8.16500554,25.8611489 8.39806437,25.8611489 C8.5866526,25.8611489 8.7768879,25.7964255 8.9308879,25.6636596 C9.27759378,25.3665957 9.31959378,24.843 9.02477025,24.4936596 C2.86641731,17.1981702 6.55006437,9.80476596 6.70982907,9.49359574",
    id: "Fill-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0237114,26.0005532 C26.8072408,27.3846383 24.486535,26.8535745 24.4675938,26.8502553 C24.026182,26.7357447 23.5790055,27.0070851 23.4670055,27.4518511 C23.3566526,27.8957872 23.6226526,28.3471915 24.0640644,28.4592128 C24.1151232,28.4716596 24.6990055,28.614383 25.7728879,28.614383 C27.0378291,28.614383 28.982182,28.4168936 31.5334761,27.5788085 C34.902535,26.4727021 36.2522997,27.027 36.498535,27.3414894 C36.7167702,27.7148936 37.1902997,27.8559574 37.5806526,27.6568085 C37.9850055,27.4485319 38.1464173,26.9481702 37.9397114,26.5399149 C37.7354761,26.1382979 36.4458291,24.2223191 31.0237114,26.0005532",
    id: "Fill-18"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashewNuts);
export default __webpack_public_path__ + "static/media/cashew_nuts.85d45b08baa498b719f0698b934ab536.svg";
export { ForwardRef as ReactComponent };